import React from 'react';

const AstronautMascot = ({ className = "w-64 h-64", animated = true }) => {
  return (
    <svg
      viewBox="0 0 400 400"
      className={`${className} ${animated ? 'animate-float' : ''}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Helmet glow */}
      <circle cx="200" cy="140" r="90" fill="url(#helmetGlow)" opacity="0.3" />
      
      {/* Body */}
      <ellipse cx="200" cy="260" rx="70" ry="90" fill="#E5E5E5" />
      
      {/* Body stripes */}
      <rect x="130" y="230" width="140" height="8" rx="4" fill="#EF4444" />
      <rect x="130" y="280" width="140" height="8" rx="4" fill="#EF4444" />
      
      {/* Backpack */}
      <rect x="220" y="200" width="45" height="80" rx="8" fill="#9CA3AF" />
      <rect x="230" y="210" width="25" height="25" rx="4" fill="#6366F1" opacity="0.7" />
      <circle cx="242" cy="260" r="6" fill="#EF4444" />
      
      {/* Left arm */}
      <ellipse cx="130" cy="240" rx="25" ry="50" fill="#E5E5E5" transform="rotate(-20 130 240)" />
      <circle cx="115" cy="270" r="20" fill="#D1D5DB" />
      
      {/* Right arm holding hot dog */}
      <ellipse cx="270" cy="240" rx="25" ry="50" fill="#E5E5E5" transform="rotate(20 270 240)" />
      <circle cx="285" cy="270" r="20" fill="#D1D5DB" />
      
      {/* Hot Dog - bun */}
      <ellipse cx="310" cy="265" rx="45" ry="18" fill="#F59E0B" />
      <ellipse cx="310" cy="262" rx="45" ry="15" fill="#FCD34D" />
      
      {/* Hot Dog - sausage */}
      <ellipse cx="310" cy="265" rx="38" ry="12" fill="#DC2626" />
      <ellipse cx="310" cy="263" rx="38" ry="10" fill="#EF4444" />
      
      {/* Mustard on hot dog */}
      <path
        d="M 280 265 Q 290 260, 300 265 T 320 265 Q 330 268, 340 265"
        stroke="#FCD34D"
        strokeWidth="3"
        fill="none"
        strokeLinecap="round"
      />
      
      {/* Legs */}
      <rect x="170" y="330" width="25" height="50" rx="12" fill="#E5E5E5" />
      <rect x="205" y="330" width="25" height="50" rx="12" fill="#E5E5E5" />
      
      {/* Boots */}
      <ellipse cx="182" cy="375" rx="18" ry="12" fill="#374151" />
      <ellipse cx="217" cy="375" rx="18" ry="12" fill="#374151" />
      
      {/* Helmet */}
      <circle cx="200" cy="140" r="75" fill="url(#helmetGradient)" opacity="0.9" />
      
      {/* Helmet shine */}
      <ellipse cx="170" cy="120" rx="25" ry="35" fill="white" opacity="0.4" />
      <ellipse cx="185" cy="110" rx="15" ry="20" fill="white" opacity="0.6" />
      
      {/* Visor */}
      <ellipse cx="200" cy="145" rx="55" ry="45" fill="#1E293B" opacity="0.8" />
      
      {/* Visor reflection */}
      <ellipse cx="180" cy="135" rx="20" ry="15" fill="#06B6D4" opacity="0.5" />
      <ellipse cx="210" cy="140" rx="15" ry="10" fill="#06B6D4" opacity="0.3" />
      
      {/* Face inside helmet */}
      <ellipse cx="200" cy="150" rx="35" ry="30" fill="#FCD34D" opacity="0.3" />
      
      {/* Helmet ring connector */}
      <ellipse cx="200" cy="200" rx="60" ry="15" fill="#9CA3AF" />
      <ellipse cx="200" cy="198" rx="60" ry="12" fill="#D1D5DB" />
      
      {/* Control panel on chest */}
      <rect x="175" y="215" width="50" height="30" rx="6" fill="#374151" />
      <circle cx="190" cy="230" r="5" fill="#10B981" opacity="0.8" />
      <circle cx="210" cy="230" r="5" fill="#EF4444" opacity="0.8" />
      <rect x="180" y="238" width="15" height="3" rx="1.5" fill="#06B6D4" />
      <rect x="205" y="238" width="15" height="3" rx="1.5" fill="#F59E0B" />
      
      {/* Stars around astronaut */}
      <circle cx="80" cy="100" r="3" fill="#F59E0B" opacity="0.8">
        <animate attributeName="opacity" values="0.8;0.3;0.8" dur="2s" repeatCount="indefinite" />
      </circle>
      <circle cx="320" cy="120" r="2" fill="#06B6D4" opacity="0.8">
        <animate attributeName="opacity" values="0.8;0.3;0.8" dur="3s" repeatCount="indefinite" />
      </circle>
      <circle cx="100" cy="300" r="2.5" fill="#F59E0B" opacity="0.8">
        <animate attributeName="opacity" values="0.8;0.3;0.8" dur="2.5s" repeatCount="indefinite" />
      </circle>
      <circle cx="310" cy="330" r="2" fill="#06B6D4" opacity="0.8">
        <animate attributeName="opacity" values="0.8;0.3;0.8" dur="2.8s" repeatCount="indefinite" />
      </circle>
      
      {/* Gradients */}
      <defs>
        <linearGradient id="helmetGradient" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#06B6D4" stopOpacity="0.6" />
          <stop offset="100%" stopColor="#0891B2" stopOpacity="0.3" />
        </linearGradient>
        <radialGradient id="helmetGlow">
          <stop offset="0%" stopColor="#06B6D4" stopOpacity="0.4" />
          <stop offset="100%" stopColor="#06B6D4" stopOpacity="0" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export default AstronautMascot;
